import {
  AvailableModuleinfo,
  EnabledModuleInfo,
  PaidModuleTypeFlags,
  paidModuleTypes,
} from '../constants/paidModuleTypes';
import { EntityType } from '../constants/user-info/ENTITY_TYPES';
import { paidModulesService } from '../services/paidModulesService';
import { getFlagsObject } from './sortingAndGroupingUtil';

export const getAvailableModules = async (
  entityType: EntityType,
): Promise<PaidModuleTypeFlags> => {
  const availableModules = await paidModulesService.getAvailableModules(entityType);

  return getModulesBoolObj(availableModules);
};

export const getEnabledModules = async (
  entityId: number,
): Promise<PaidModuleTypeFlags> => {
  const enabledModules = await paidModulesService.getEnabledModules(entityId);

  return getModulesBoolObj(enabledModules);
};

export const getCustomerAvailableModules = async (
  customerId: number,
): Promise<PaidModuleTypeFlags> => {
  const availableModules =
    await paidModulesService.getCustomerAvailableModules(customerId);

  return getModulesBoolObj(availableModules);
};

export const getModulesBoolObj = (
  paidModules: EnabledModuleInfo[] | AvailableModuleinfo[],
) => {
  const paidModulesList = paidModules.map((module) => module.paidServiceType);

  return getFlagsObject(paidModuleTypes, paidModulesList);
};
